import { StatusValue } from '@/shared';

export const actionRequiredStatus = [
  StatusValue.Quoted,
  StatusValue.Blocked,
  StatusValue.InQA,
  StatusValue.Pending,
];

export function isActionRequired(status?: StatusValue) {
  if (!status) {
    return false;
  }

  return actionRequiredStatus.includes(status);
}
